<div class="toast-container">
   <app-icon *ngIf="!isInfoToast" [icon]="getIconPath(data.type)"></app-icon>
  <div class="toast-content">
    <p [style]="'fontSize.24' | translate">{{ data?.message | translate }}</p>
  </div>
</div>
